import { Today } from '@mui/icons-material';
import { IconButton, MenuItem } from '@mui/material';
import { LocalizationProvider, StaticDatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Menu, MenuButton } from '@retail/components';

interface Props {
  disabled?: boolean;
  handleChangeDate: (newDate: Date | null) => void;
}

export function DateSelectMenu({ disabled, handleChangeDate }: Props) {
  return (
    <Menu>
      {({ onClose }) => (
        <>
          <MenuButton component={IconButton}>
            <Today />
          </MenuButton>
          <MenuItem
            sx={{
              bgcolor: 'background.paper',
              ':focus': { bgcolor: 'background.paper' },
              '&.MuiButtonBase-root': {
                bgcolor: 'background.paper',
              },
            }}
          >
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <StaticDatePicker
                disabled={disabled}
                slots={{ toolbar: () => undefined, actionBar: () => undefined }}
                disablePast
                onChange={(newDate) => {
                  handleChangeDate(newDate);
                  onClose();
                }}
              />
            </LocalizationProvider>
          </MenuItem>
        </>
      )}
    </Menu>
  );
}
